import PayrollSettingsTab from "./PayrollSettings/PayrollSettingsTab";
import SettingPageLayout from "./SettingPageLayout";

function MainPayrollSettings() {
  return <SettingPageLayout>
    <PayrollSettingsTab/>
  </SettingPageLayout>;
}

export default MainPayrollSettings;
